import './loader.scss';
import React from 'react';
import classnames from 'classnames';

const Loader = ({
    loading = true,
    isGrey = false,
    isSmall = false,
    isInline = false,
    className = ''
}) => {

        const classes = classnames({
            loader: true,
            'is-visible': loading,
            'is-grey': isGrey,
            'is-inline': isInline
        }, className);

        const iconClasses = isSmall ? 'loader-icon--is-small' : 'loader-icon';

        return (
            <div className={classes}>
                <div className={iconClasses}>
                    <div className="aui-preloader">
                        <div className="aui-preloader__spinner">
                            <div className="aui-preloader__clipper">
                                <div className="aui-preloader__circle" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
};

export default Loader;
